<div
  class="ui-field-status-row"
  [class.ui-field-status-row-ok]="isOk()"
  [class.ui-field-status-row-ai]="isAi()"
  [class.ui-field-status-row-required]="isRequired()"
  [class.ui-field-status-row-optional]="isOptional()"
  [attr.aria-invalid]="isBlocking() ? 'true' : null"
  [attr.data-blocking]="isBlocking() ? 'true' : null"
>
  <div class="ui-field-status-row-main">
    <span class="ui-field-status-row-label">{{ label() }}</span>
    <span class="ui-field-status-row-value-group">
      @if (isRequired()) {
        <span class="ui-field-status-row-alert" aria-hidden="true">!</span>
      }
      <span class="ui-field-status-row-value">{{ displayValue() }}</span>
    </span>
  </div>
  @if (isAi() || editable()) {
    <span class="ui-field-status-row-accessories">
      @if (isAi()) {
        <ui-meta-chip variant="ai">AI</ui-meta-chip>
      }
      @if (editable()) {
        <button
          class="ui-field-status-row-edit"
          type="button"
          [attr.aria-label]="editLabel()"
          (click)="handleEdit()"
        >
          {{ editLabel() }}
        </button>
      }
    </span>
  }
  @if (hasHelperText()) {
    <span class="ui-field-status-row-helper">{{ helperText() }}</span>
  }
</div>
